module.exports = __webpack_public_path__ + "static/media/BNB_BANANA_APE.51fca94f.png";